<p class="truncated-paragraph" [class.truncated]="isTruncated" #paragraph>
    <span class="text" [innerHtml]="truncatedText" #paragraphText></span>
    <a href="#" *ngIf="isLengthExceedLimit" (click)="toggleText($event)">
        {{ isTruncated ? 'show more' : 'show less'}}
    </a>
</p>